module.exports = __webpack_public_path__ + "img/project3_2.png.3767ef8c.webp";